export default __webpack_public_path__ + "static/media/twitter.e8d56fff.svg";